import CookieService from './CookieService'

class CookieAcceptanceService extends CookieService {
    ACCEPTED_COOKIE = 'is_accepted_cookie_consent'

    constructor() {
        super()

        const acceptedCookie = this.get(this.ACCEPTED_COOKIE)

        if (acceptedCookie) {
            this.setAcceptedCookie(acceptedCookie)
        }
    }

    setAcceptedCookie(acceptedCookie) {
        
        this.set(this.ACCEPTED_COOKIE, acceptedCookie, {
            domain: window.location.hostname,
        })
      
    }

    getAcceptedCookie() {
        return this.get(this.ACCEPTED_COOKIE)
    }

    isAcceptedCookie() {
        return this.getAcceptedCookie() === 'true'
    }

    deleteAcceptedCookie() {
        this.remove(this.ACCEPTED_COOKIE)
    }

    clear() {
        this.deleteAcceptedCookie()
    }
    

}

const cookieAcceptanceService = new CookieAcceptanceService()

export default cookieAcceptanceService